import { render, staticRenderFns } from "./create-dossier.vue?vue&type=template&id=20f9e4a4&scoped=true"
import script from "./create-dossier.vue?vue&type=script&lang=ts"
export * from "./create-dossier.vue?vue&type=script&lang=ts"
import style0 from "./create-dossier.vue?vue&type=style&index=0&id=20f9e4a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f9e4a4",
  null
  
)

export default component.exports